import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { COMPANY_DETAILS_KEYS } from 'aurora-containers/Routes/Service/Company/RegisterCompany/constants';
import * as types from './constants';

const initialState = {
  loading: false,
  error: null,
  currentStep: 0,
  companyValidationResponse: null,
  application: {},
  lookups: {},
  lookupsErrors: [],
  documents: [],
  companyDetail: {},
  formErrors: {},
};

function companyReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.REGISTER_COMPANY_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.REGISTER_COMPANY_CLEAR_LOADING:
      return {
        ...state,
        loading: false,
      };
    case types.REGISTER_COMPANY_ERROR:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error || action?.payload,
        formErrors: get(action.payload, 'errors', {}),
      };
    case types.REGISTER_COMPANY_FORM_ERROR:
      return {
        ...state,
        formErrors: {
          ...state.formErrors,
          [action?.payload?.key]: action?.payload.value,
        },
      };
    case types.REGISTER_COMPANY_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.REGISTER_COMPANY_CLEAR_FORM_ERROR:
      return {
        ...state,
        formErrors: {},
      };
    case types.REGISTER_COMPANY_FETCH_LICENSE_LOOKUP_SUCCESS:
      return {
        ...state,
        loading: false,
        licenseSources: get(action.payload, 'licenseSources', []),
      };
    case types.REGISTER_COMPANY_VALIDATE_COMPANY_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        companyValidationResponse: get(action.payload, 'result'),
      };
    case types.REGISTER_COMPANY_FETCH_APPLICATION_SUCCESS:
      const application = get(action.payload, 'application', {});
      const companyDetail = {};
      if (!isEmpty(application?.companyDetail)) {
        Object.values(COMPANY_DETAILS_KEYS)?.forEach(curKey => {
          companyDetail[curKey] = application?.companyDetail[curKey];
        });
      }
      companyDetail.companyActivity = application?.companyActivityList;
      return {
        ...state,
        loading: false,
        application,
        companyDetail,
      };
    case types.REGISTER_COMPANY_FETCH_LOOKUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        lookups: get(action.payload, 'lookups', {}),
        lookupsErrors: get(action.payload, 'lookupsErrors', []),
      };
    case types.REGISTER_COMPANY_SET_COMPANY_DETAILS:
      return {
        ...state,
        companyDetail: {
          ...state.companyDetail,
          [action?.payload?.key]: action?.payload?.value,
        },
      };
    case types.REGISTER_COMPANY_SET_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.REGISTER_COMPANY_DOWNLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.REGISTER_COMPANY_CHECKOUT_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.REGISTER_COMPANY_CHANGE_WORKFLOW_STEP:
      return {
        ...state,
        currentStep: get(action.payload, 'step'),
      };
    case types.REGISTER_COMPANY_CLEAR_TRADE_LICENSE_VALIDATION_RESPONSE:
      return {
        ...state,
        companyValidationResponse: null,
      };
    case types.REGISTER_COMPANY_CLEAR_APPLICATION_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}

export default companyReducer;
